import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Enterprise } from 'models/Enterprises';
import { EnterpriseTable } from '../../data';
import { getEnterpriseRoute, normalizeEmail } from 'utils';

type CellProps = {
  enterprise: Enterprise;
  config?: Record<string, string>;
};

const NameCell: React.FC<CellProps> = ({ enterprise }) => {
  const { brandName } = enterprise || {};

  return <p>{brandName}</p>;
};

const PrincipalCell: React.FC<CellProps> = ({ enterprise }) => {
  const { principals } = enterprise || {};

  return <p>{(principals || []).map((p) => normalizeEmail(p.email)).join(', \n')}</p>;
};

const BusinessUnitsCellComponent: React.FC<CellProps> = ({ enterprise }) => {
  const { numberOfBusinessUnits } = enterprise || {};

  return <p>{numberOfBusinessUnits}</p>;
};

const EmployeesCellComponent: React.FC<CellProps> = ({ enterprise }) => {
  const { numberOfEmployees } = enterprise || {};

  return <p>{numberOfEmployees}</p>;
};

const DealsCellComponent: React.FC<CellProps> = ({ enterprise }) => {
  const { numberOfDeals } = enterprise || {};

  return <p>{numberOfDeals}</p>;
};

const ManageCellComponent: React.FC<CellProps> = ({ enterprise }) => {
  const { _id } = enterprise || {};

  const { t } = useTranslation();

  return (
    <Link to={`${_id}/manage-people`} onClick={(e) => e.stopPropagation()}>
      {t('managePeople')}
    </Link>
  );
};

const EditCellComponent: React.FC<CellProps> = ({ enterprise }) => {
  const { _id } = enterprise || {};

  const { t } = useTranslation();

  return (
    <Link to={_id} onClick={(e) => e.stopPropagation()}>
      {t('edit')}
    </Link>
  );
};

const AnalyticsCellComponent: React.FC<CellProps> = ({ enterprise }) => {
  const { _id, isRWC, isDemo } = enterprise || {};

  const { t } = useTranslation();

  return (
    <Link
      to={getEnterpriseRoute(isRWC, isDemo, _id, 'analytics')}
      onClick={(e) => e.stopPropagation()}
    >
      {t('analytics')}
    </Link>
  );
};

export const BODY_CONTENT_GENERATE: Record<
  keyof EnterpriseTable,
  (cellProps: CellProps) => ReactNode
> = {
  _id: null,
  brandName: (cellProps: CellProps) => <NameCell {...cellProps} />,
  principal: (cellProps: CellProps) => <PrincipalCell {...cellProps} />,
  businessUnits: (cellProps: CellProps) => (
    <BusinessUnitsCellComponent {...cellProps} />
  ),
  employeesCount: (cellProps: CellProps) => (
    <EmployeesCellComponent {...cellProps} />
  ),
  dealsCount: (cellProps: CellProps) => <DealsCellComponent {...cellProps} />,
  manageLink: (cellProps: CellProps) => <ManageCellComponent {...cellProps} />,
  editLink: (cellProps: CellProps) => <EditCellComponent {...cellProps} />,
  analyticsLink: (cellProps: CellProps) => (
    <AnalyticsCellComponent {...cellProps} />
  ),
};
